import { configureStore } from "@reduxjs/toolkit";
import authAndAddressReducer from "./slices/authAndAddressSlice";
import categoriesReducer from "./slices/categoriesSlice";
import cartReducer from "./slices/cartSlice";
import locationReducer from "./slices/LocationSlice";
import addressReducer from "./slices/AddressSlice";
import timeAndDateReducer from "./slices/TimeandDateSlice";
import deviceReducer from "./slices/DeviceSlice";
import bookingReducer from "./slices/BookingSlice";
import CouponReducer from "./slices/CouponSlice";
import userConfigReducer from "./slices/ConfigSlice";
import blogReducer from "./slices/blogSlice";
import trackReducer from "./slices/trackSlice";

export const store = configureStore({
  reducer: {
    auth: authAndAddressReducer,
    category: categoriesReducer,
    cart: cartReducer,
    location: locationReducer,
    address: addressReducer,
    timeandDate: timeAndDateReducer,
    device: deviceReducer,
    coupon: CouponReducer,
    booking: bookingReducer,
    config: userConfigReducer,
    blog: blogReducer,
    track: trackReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
